import { faroCoreApiClient } from "@api/faro-core-api-client";
/**
 * Fetches the teams of a workspace, optionally only those a member belongs to.
 *
 * "memberIdentity" is not yet part of the published GetTeamsPayload type, so the payload type is
 * widened to forward it as a query param.
 */
export function getTeams({
  companyId,
  search,
  memberIdentity
}) {
  const payload = {
    search,
    ...(memberIdentity ? {
      memberIdentity
    } : {})
  };
  return faroCoreApiClient.teams.getTeams({
    companyId,
    payload
  });
}